import type {
  BookingSettlementDto,
  UnsettleBookingRequest,
} from '../Types/bookingSettlement.types';
import { bookingsApi } from './bookingsApi';
import {
  buildSettleBookingForAccountingRequest,
  buildUnsettleBookingForAccountingRequest,
  getBookingSettlementInvalidatesTags,
  getBookingSettlementProvidesTags,
  getBookingSettlementUrl,
} from './bookingSettlementApi.contract';

export const bookingSettlementApi = bookingsApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookingSettlement: builder.query<BookingSettlementDto, number>({
      query: getBookingSettlementUrl,
      providesTags: (result, error, bookingId) => getBookingSettlementProvidesTags(bookingId),
    }),
    settleBookingForAccounting: builder.mutation<void, number>({
      query: buildSettleBookingForAccountingRequest,
      invalidatesTags: (result, error, bookingId) =>
        getBookingSettlementInvalidatesTags(bookingId),
    }),
    unsettleBookingForAccounting: builder.mutation<void, UnsettleBookingRequest>({
      query: buildUnsettleBookingForAccountingRequest,
      invalidatesTags: (result, error, { bookingId }) =>
        getBookingSettlementInvalidatesTags(bookingId),
    }),
  }),
});

export const {
  useGetBookingSettlementQuery,
  useSettleBookingForAccountingMutation: useBookingsSettleForAccountingMutation,
  useUnsettleBookingForAccountingMutation: useBookingsUnsettleForAccountingMutation,
} = bookingSettlementApi;
